import { useCallback, useState } from 'react'
import { flushSync } from 'react-dom'

/**
 * @description hook for store accountId and displayName
 */
export const useReplyToComment = () => {
  const [data, setData] = useState<{
    replyToAccountId?: string
    replyToDisplayName?: string
    replyToCommentId?: string
  }>({})

  const onReplyToReply = useCallback(
    (params: {
      accountId: string
      displayName: string
      commentId?: string
    }) => {
      flushSync(() => {
        setData({})
      })
      flushSync(() => {
        setData({
          replyToAccountId: params.accountId,
          replyToDisplayName: params.displayName,
          replyToCommentId: params.commentId,
        })
      })
    },
    []
  )

  const onRemoveReplyToReply = useCallback(() => {
    setData({})
  }, [])

  return { data, onReplyToReply, onRemoveReplyToReply }
}
